export default __webpack_public_path__ + "static/media/CRChurchillClosed.7b00874c.jpg";